import {NgModule} from '@angular/core';
import {DefTitleSelect} from "./def-title-select/def-title-select";
import {DefTitleSelectSearch} from "./def-title-select/def-title-select-search";

@NgModule({
    declarations: [DefTitleSelect,DefTitleSelectSearch],
    imports: [],
    exports: [DefTitleSelect,DefTitleSelectSearch]
})
export class DirectivesModule {
}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts